<template>
<w-settings-content-template :default-content="!registWizardFlag">
  <div slot="content" v-show="!registWizardFlag">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">관리 대상 목록</div>
        <!-- 0429 버튼 타입 변경 -->
        <el-button class="mr-r4" type="secondary" size="mini" @click="onRegistDeviceButton">등록 마법사</el-button>
        <el-button class="mr-r15" size="mini" :disabled="selectedRowArray.length === 0" @click="onDelDevice">장비 삭제</el-button>
        <span class="mr-r5">관리여부</span>
        <div class="setting-addel">
          <el-button size="mini" @click="AllCheckChangeButtonClick('1')"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" @click="AllCheckChangeButtonClick('0')"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-checkbox :checked="beforeThreeDayFlag" v-model="beforeThreeDayFlag" @change="loadData(true)"> 최근 3일 이내 등록된 장비 <em>{{recentRegisteredServiceCount}}개</em></el-checkbox>
        <el-button class="mr-r4" type="primary" size="mini" @click="onSaveButton" :disabled="!changeFlag">저장</el-button>
        <el-button class="mr-r4" size="mini" @click="onResetButton" :disabled="!changeFlag">취소</el-button>
        <w-header-pagination class="mr-r4" :pagination="pagination" @current-change="handlerHeaderCurrentChange"></w-header-pagination>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" ref="serviceTable" @selection-change="changeHandleSelection" @row-dblclick="onDblClickRow"
      :data="tableData" :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool" :column-default="columnDefault"
      @condition-change="onChangeTable"
      @pagination-change="handlerPaginationChange"
      @total-change="handlerPaginationChange"
      :total="total" remote style="width:100%;" :show-custom-header="true" row-class-name="c-dblclick">
      <template slot-scope="scope" slot="management-status">
          <el-switch @change="checkChangeFlag" v-model="scope.row.objManagementApplyFlag" active-value="1" inactive-value="0"></el-switch>
        </template>
    </el-table-wrapper>
  </div>
  <div slot="content" v-show="registWizardFlag" class="content" style="height:100%;">
    <w-service-regist-wizard ref="wizardComp" @load-data="loadData" @on-back-to-home-button="onBackToHomeButton"></w-service-regist-wizard>
  </div>
</w-settings-content-template>
</template>

<script>
import { columnDefault, defaultPagination } from '@/constants/table';
import DeviceRegistrationSvcAPI from '@/api/settings/common/device-registration-svc';
import msgUtil from '@/utils/message';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import differenceWith from 'lodash/differenceWith';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WHeaderPagination from '@/components/table/HeaderPagination';
import WServiceRegistWizard from './components/ServiceRegistWizard';

const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WService',
  components: {
    WSettingsContentTemplate,
    WServiceRegistWizard,
    WHeaderPagination,
  },
  data() {
    return {
      pagination,
      isLoading: false,
      columnDefault,
      total: null,
      registWizardFlag: false,
      recentRegisteredServiceCount: 0,
      changeFlag: false,
      showSearchTool: false,
      beforeThreeDayFlag: false,
      selectedRowArray: [],
      tableData: [],
      tableDataOrigin: [],
      loadFromThreeDataFlag: false,
      tableColumn: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objManagementApplyFlag',
          label: '관리여부',
          scopedSlot: 'management-status',
          remoteProp: 'define.objManagementApplyFlag',
          width: 85,
          sortable: true,
          filters: [
            {
              text: '관리',
              value: '1',
            },
            {
              text: '비관리',
              value: '0',
            },
          ],
        },
        {
          prop: 'objName',
          label: '서비스명',
          sortable: true,
          searchable: true,
          remoteProp: 'define.objName',
        },
        {
          prop: 'objCount',
          width: 100,
          label: '연결 장비 수',
          remoteProp: 'define.objCount',
        },
        {
          prop: 'rscCount',
          width: 100,
          label: '연결 자원 수',
          remoteProp: 'rscCount',
        },
        {
          prop: 'serviceDesc',
          label: '설명',
          searchable: true,
          formatter: this.formatterForCheckEmptyValue,
          remoteProp: 'define.serviceDesc',
        },
        {
          prop: 'registDatetime',
          label: '서비스등록일시',
          formatter: this.getDateFormatter,
          remoteProp: 'define.registDatetime',
          searchType: 'date',
          sortable: true,
          searchable: true,
          width: 130,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.serviceTable.getParameter();
      const params = {
        ...tableParams,
        beforeThreeDayFlag: this.beforeThreeDayFlag,
      };
      // '최근 3일 이내 등록된 장비' 클릭 시 start 값이 기존 값으로 남아있는 문제 인지, 초기화 추가
      if (this.loadFromThreeDataFlag) {
        params.start = 0;
      }
      // 서비스 목록 조회
      DeviceRegistrationSvcAPI.getServiceList(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.tableDataOrigin = cloneDeep(res.data.data);
          this.total = res.data.total;
        }
      });
      // 최근 등록 카운팅
      this.isLoading = true;
      this.loadFromThreeDataFlag = false;
      DeviceRegistrationSvcAPI.getRecentServiceCount().then((res) => {
        if (res.data.success) {
          this.recentRegisteredServiceCount = res.data.data;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * [테이블 페이징] 페이지 변경 핸들러
     * @author Ju
     * @param  {Object} pagination 페이지 정보 객체
     */
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    /**
     * [헤더 페이징] 현재 페이지 변경 핸들러
     * @author Ju
     * @param  {Number} currentPage 현재 페이지 번호
     */
    handlerHeaderCurrentChange(_currentPage) {
      this.$refs.serviceTable.setCurrentPage(_currentPage);
    },
    formatterForCheckEmptyValue(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onChangeTable() {
      this.loadData();
    },
    onRegistDeviceButton() {
      this.registWizardFlag = true;
      this.$nextTick(() => {
        this.$refs.wizardComp.onSettingByWizardMode('add');
      });
    },
    // 장비 삭제
    onDelDevice() {
      const target = '관리 대상';
      const action = msgUtil.action.DELETE;

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationSvcAPI.deleteServiceList(this.selectedRowArray)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    // 수정 저장
    onSaveButton() {
      const params = differenceWith(this.tableData, this.tableDataOrigin, isEqual);
      const target = '관리 대상';
      const action = msgUtil.action.SAVE;
      DeviceRegistrationSvcAPI.updateServiceManageData(params)
        .then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    onResetButton() {
      this.tableData = cloneDeep(this.tableDataOrigin);
      this.checkChangeFlag();
    },
    onBackToHomeButton() {
      this.registWizardFlag = false;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    checkChangeFlag() {
      this.changeFlag = !isEqual(this.tableData, this.tableDataOrigin);
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    onDblClickRow(row) {
      this.registWizardFlag = true;
      this.$nextTick(() => {
        this.$refs.wizardComp.onSettingByWizardMode('update', row);
      });
    },
    AllCheckChangeButtonClick(objManagementApplyFlag) {
      this.tableData.forEach((record) => {
        record.objManagementApplyFlag = objManagementApplyFlag;
      });
      this.checkChangeFlag();
    },
    onChangeThreeFlag() {
      this.loadFromThreeDataFlag = true;
      this.$nextTick(() => {
        this.$refs.serviceTable.setCurrentPage(1);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Service/index.vue